export default "__VITE_ASSET__CbMUyOCj__"